import { ICollection } from 'meta/pages/collection'
import { useAppSelector } from 'store'
import { CollectionSelectors } from 'store/pages/collection'

export const useCollectionDetails = ({ id, language }: { id: string; language: string }): ICollection | undefined =>
  useAppSelector(CollectionSelectors.getCollectionDetails({ id, language }))
